import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import {
	GetProvinces,
	GetCitys,
	GetAreas,
	GetAgentList,
	GetParmConfig, //寄送，支付接口
	GetProductClass,
	GetAgentConsigneeList,
	Consignee_Add,
	GetEmployList,
	ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import viewDialog from './viewDialog/index.vue'
export default {
	mixins: [services],
	components: {
		viewDialog
	},
	data() {
		return {
			Session: util.getSessin(),
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			query: this.getFormData()

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				OrderCode: "",
				UserName: "",
				startDate: "",
				endDate: "",
				endDate: "",
				userTel: '',
				babyName: '',
				babyId: '',

			});
		},
		//查看订单
		handleView(index, row) {
			this.$refs.refViewDialog.show({
				OrderId: row.OrderId,
				title: '订单详情',
			})
		},

		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		},
		//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList();
		},
		onQueryClean: function () {
			this.query = this.getFormData();
			this.getList();
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.getList();
	},

}


// WEBPACK FOOTER //
// ./src/pages/Family/NoPayOrderList/vm.js